import jQuery from 'jquery';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;
const { Customer } = Mobi2Go;
const { headoffice } = Mobi2Go;
const { CustomerAddress } = Mobi2Go._class;

UI.View({
    name: 'customer_address',
    model: Order,
    el: '[data-view="customer-address"]',
    template: jQuery('[data-template="customer-address"]').html(),
    initialise() {
        this.modal = new Mobi2Go.UI.Modal(this.$el);
        Mobi2Go.UI.bind('showCustomerAddresses', this.show);
        this.$el.localize();
    },
    model_listeners: {
        updateAddress(address) {
            if (!address) this.clearFormData();
        },
    },
    address_id: null,
    render(address_id, type) {
        let address;
        const addresses = Order.getAvailableAddresses();

        this.setSpinner(false);

        address_id = +address_id;

        if (address_id) {
            // render the form populated by an address
            address = Mobi2Go.Customer.getAddressById(address_id);
            this.address_id = address_id;
        } else {
            address = this.createAddressInstanceFromForm();
            this.address_id = null;
        }

        if (type) {
            address.type = type;
        }

        const template_data = {
            address,
            address_id: this.address_id,
            addresses,
            delivery_areas: Order.getAvailableDeliveryAreas(),
        };

        const html = this.template(template_data);
        this.jQuery('[data-form]').html(html);

        Mobi2Go.UI.trigger('customerAddressRendered', address);
    },
    createAddressInstanceFromForm() {
        return new CustomerAddress(
            {
                name: this.jQuery('[data-name]').val(),
                specific_number: this.jQuery('[data-specific-number]').val(),
                street_number: this.jQuery('[data-street-number]').val(),
                street_name: this.jQuery('[data-street-name]').val(),
                suburb_id: +this.jQuery('[data-suburb]').val(),
                post_code: this.jQuery('[data-post-code]').val(),
                comment: this.jQuery('[data-comment]').val(),
            },
            Order.getCustomer()
        );
    },
    clearFormData() {
        this.jQuery('[data-type]').val('');
        this.jQuery('[data-name]').val('');
        this.jQuery('[data-specific-number]').val('');
        this.jQuery('[data-street-number]').val('');
        this.jQuery('[data-street-name]').val('');
        this.jQuery('[data-suburb]').val('');
        this.jQuery('[data-post-code]').val('');
        this.jQuery('[data-comment]').val('');
    },
    DOM_listeners: {
        'change [data-addresses]': 'changeAddress',
        'change [data-type]': 'changeAddressType',
        'click [data-new-address]': 'newAddress',
        'click [data-confirm]': 'saveAddress',
    },
    changeAddress() {
        const address_id = this.jQuery('[data-addresses]').val();
        this.render(address_id);
    },
    changeAddressType() {
        const type = this.jQuery('[data-type]').val();
        this.render(this.address_id, type);
    },
    newAddress() {
        this.address_id = null;
        this.clearFormData();
        this.render();
    },
    saveAddress() {
        const new_address = this.createAddressInstanceFromForm();
        const that = this;

        // Secondary validation :\
        try {
            new_address.validate();
        } catch (error) {
            UI.centeredAlert({
                title: 'Invalid address',
                body: error.message,
            });

            return;
        }

        this.setSpinner(true);

        try {
            if (this.address_id) {
                Customer.updateAddressById(
                    this.address_id,
                    new_address,
                    saveCallback
                );
            } else {
                Customer.createAddress(new_address).save(saveCallback);
            }
            this.setSpinner(false);
        } catch (error) {
            this.setError(error.message);
            this.setSpinner(false);
        }

        function saveCallback(response) {
            Mobi2Go.Order.setAddressById(response.id, true);
            that.address_id = response.id;
            that.hide();
        }
    },
    setSpinner(status) {
        this.jQuery('[data-spinner]')[status ? 'show' : 'hide']();
        this.jQuery('[data-confirm]')[status ? 'hide' : 'show']();
    },
    setError(message) {
        if (message) {
            this.jQuery('[data-error]')
                .show()
                .text(message);
        } else {
            this.jQuery('[data-error]').hide();
        }
    },
    show() {
        if (Order.getLocation().delivery.mode !== 'suburb_list') {
            return;
        }

        if (Order.getMethod() !== 'delivery') {
            return;
        }

        if (!Customer.isLoggedIn()) {
            Mobi2Go.UI.trigger('promptProgress');
            return;
        }

        if (Customer.shouldPromptSMSVerification()) {
            return;
        }

        // If there is currently an address set to the order, show it loaded
        // into the form when the dialog is shown
        const order_address = Order.getAddress();
        this.render((order_address && order_address.id) || null);

        this.modal.open();

        this.jQuery('[data-type]').focus();
    },
    hide() {
        this.modal.close();
    },
});
